import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    paragraph = "paragraph",
    linkText = "linkText",
    link = "link",
    blocks = "blocks"
}

interface OwnProps extends WidgetProps {
    paragraph: fields.paragraph,
    linkText: fields.linkText,
    link: fields.link,
    extendedStyles?: BannerStyles;
}

export interface BannerStyles {
    overlayWrapperStyles?: InjectableCss;
    titleStyles?: InjectableCss;
}

const mapStateToProps = (state: ApplicationState) => ({
});

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;
export interface ExploreOpportunityStyles {
    container?: GridContainerProps;
    customDescriptionText?: TypographyPresentationProps;
    linkStyle?: LinkPresentationProps;
    description?: TypographyPresentationProps;
    exploreOpportunityButton?: InjectableCss;
    wrapper?: InjectableCss;
    triangleUpLeft?: InjectableCss;
    triangleUpRight?: InjectableCss;
    opportunityLeftGrid?: GridItemProps;
    opportunityRightGrid?: GridItemProps;
}

export const exploreOpportunityStyles: ExploreOpportunityStyles = {
    wrapper: {
        css: css`
            padding: 0px 18%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            
                        `,
                        css`
                            
                        `,
                        css`
                           
                        `,
                        css`
                            padding: 0px 6%;
                        `,
                        null,
                    ],
                    "max",
                )}
        `
    },
    container: {
        css: css`
            position: relative;
            bottom: 41px;
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            
                        `,
                        css`
                            
                        `,
                        css`
                            bottom: 34px;
                        `,
                        css`
                            bottom: 34px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `
    },
    description: {
        css: css`
            font-family: SourceSans3-Light;
            color: #FFFFFF;
        `
    },
    linkStyle: {
        css: css`
           text-transform: uppercase;
        `
    },
    exploreOpportunityButton: {
        css: css`
            background-color: #3AB54A;
            border-radius: 2px;
            padding: 10px;
            font-size: 14px;
            span {
                color: #FFFFFF !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            
                        `,
                        css`
                            
                        `,
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `
    },
    triangleUpLeft: {
        css: css`
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 0px solid transparent;
            border-top: 22px solid #03345F;
            z-index: 0;
            position: relative;
            top: 19px;
            left: -30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            border-top: 27px solid #03345F;
                            top: 16px;
                        `,
                        css`
                            border-top: 27px solid #03345F;
                            top: 16px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `
    },
    triangleUpRight: {
        css: css`
            width: 0;
            height: 0;
            border-left: 0px solid transparent;
            border-right: 15px solid transparent;
            border-top: 22px solid #03345F;
            z-index: 0;
            position: relative;
            top: 28px;
            left: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            border-top: 27px solid #03345F;
                            top: 22px;
                        `,
                        css`
                            border-top: 27px solid #03345F;
                            top: 22px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `
    },
    opportunityLeftGrid: {
        css: css`
            padding: 10px 15px;
            background-color: #2E64B0;
            z-index: 999;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: center;
                        `,
                        css`
                            justify-content: center;
                        `,
                        css`
                            
                        `,
                        css`
                            .explore-opportunity {
                                font-size: 13px;
                            }
                        `,
                        null,
                    ],
                    "max",
                )}
        `
    },
    opportunityRightGrid: {
        css: css`
            padding: 10px 15px;
            background-color: #2E64B0;
            z-index: 999;
            justify-content: right;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: center;
                        `,
                        css`
                            justify-content: center;
                        `,
                        css`
                            justify-content: center;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    }

}

const styles = exploreOpportunityStyles;
const ExploreOpportunity: React.FunctionComponent<Props> = ({ fields }: Props) => {

    return (
        <StyledWrapper {...styles.wrapper} className="ExploreOpportunity">
            <GridContainer gap={0} {...styles.container} className="ExploreOpportunity-container">
                <GridItem width={[12, 12, 8, 8, 8]} {...styles.opportunityLeftGrid}>
                <StyledWrapper className="triangle-up" {...styles.triangleUpLeft}></StyledWrapper>
                    <Typography {...styles.description}>
                        {parse(fields.paragraph, parserOptions)}
                    </Typography>
                </GridItem>
                <GridItem width={[12, 12, 4, 4, 4]} {...styles.opportunityRightGrid}>
                    <StyledWrapper {...styles.exploreOpportunityButton}>
                        <Link href={fields.link.value} {...styles.linkStyle} target="_blank">
                            {translate(fields.linkText)}
                        </Link>
                    </StyledWrapper>
                <StyledWrapper className="triangle-up" {...styles.triangleUpRight}></StyledWrapper>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    )
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ExploreOpportunity),
    definition: {
        group: "Basic",
        displayName: "Explore Opportunity",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.paragraph,
                editorTemplate: "RichTextField",
                displayName: "",
                defaultValue: "",
                extendedConfig: { height: 100 },
            },
            {
                fieldType: "Translatable",
                name: fields.linkText,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.link,
                displayName: "Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
        ],
    },
};

export default widgetModule;